import Request from "../request";
import { CustomStrategyStatus } from "constants/strategy";

const request = new Request();

export interface StrategyStats {
  new_count: string;
  contacting_count: string;
  consulted_count: string;
  recommended_count: string;
  contract_count: string;
  closed_count: string;
}

export interface StrategyItem {
  strategy_id: number;
  user_name: string;
  user_tel: string;
  user_email: string | null;
  service_type: string | null;
  budget_range: string | null;
  status: CustomStrategyStatus;
  recommend_done: "Y" | "N";
  email_sent: "Y" | "N";
  kakao_sent: "Y" | "N";
  sms_sent: "Y" | "N";
  call_done: "Y" | "N";
  create_time: string;
}

export interface StrategyListResponse {
  list: StrategyItem[];
  totalCount: number;
  stats: StrategyStats;
}

export type StrategyCheckField =
  | "recommend_done"
  | "email_sent"
  | "kakao_sent"
  | "sms_sent"
  | "call_done";

export interface StrategyDetailItem {
  strategy_id: number;
  user_key: string;
  regions: string[] | null;
  purposes: string[] | null;
  asset_types: string[] | null;
  asset_custom: string | null;
  budget_range: string | null;
  service_type: string | null;
  channels: string[] | null;
  info_consent: "Y" | "N";
  status: CustomStrategyStatus;
  recommend_done: "Y" | "N";
  email_sent: "Y" | "N";
  kakao_sent: "Y" | "N";
  sms_sent: "Y" | "N";
  call_done: "Y" | "N";
  assignee_name: string | null;
  memo: string | null;
  assigned_at: string | null;
  create_time: string;
  user_name: string;
  user_email: string | null;
  user_tel: string;
  user_login_type: string;
  user_id: string | null;
}

export class StrategyService {
  static list = async (params: {
    search?: string;
    status?: string;
    sort?: string;
    limit: number;
    page: number;
  }): Promise<StrategyListResponse> => {
    const query = new URLSearchParams();
    if (params.search) query.set("search", params.search);
    if (params.status) query.set("status", params.status);
    if (params.sort) query.set("sort", params.sort);
    query.set("limit", String(params.limit));
    query.set("page", String(params.page));

    const { data } = await request.get(`/admin/custom-strategy?${query.toString()}`);
    return data?.data ?? data;
  };

  static getDetail = async (id: number | string): Promise<StrategyDetailItem> => {
    const { data } = await request.get(`/admin/custom-strategy/${id}`);
    return data?.data ?? data;
  };

  static updateStatus = async (id: number | string, status: CustomStrategyStatus) => {
    await request.patch(`/admin/custom-strategy/${id}/status`, { status });
  };

  static updateAssignee = async (id: number | string, name: string) => {
    await request.patch(`/admin/custom-strategy/${id}/assignee`, { name });
  };

  static updateMemo = async (id: number | string, memo: string) => {
    await request.patch(`/admin/custom-strategy/${id}/memo`, { memo });
  };

  static updateChecklist = async (id: number | string, item: StrategyCheckField, done: boolean) => {
    await request.patch(`/admin/custom-strategy/${id}/checklist`, { item, done });
  };
}
